import { c as _c } from "react/compiler-runtime";
import React, { forwardRef } from 'react';
import MUITableFooter from '@mui/material/TableFooter';
import { type TableFooterProps } from './types';
export const TableFooter = forwardRef<HTMLTableSectionElement, TableFooterProps>((t0, ref) => {
  const $ = _c(7);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props || $[5] !== ref) {
    t1 = <MUITableFooter ref={ref} {...props}>{children}</MUITableFooter>;
    $[3] = children;
    $[4] = props;
    $[5] = ref;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
});
export default TableFooter;